var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M31.17 3.88a2.03 2.03 0 0 0-1.86 2.2l4.09 35.8a2.08 2.08 0 0 0 2.3 1.76l8.35-.86a2.03 2.03 0 0 0 1.86-2.2l-4.09-35.8a2.08 2.08 0 0 0-2.3-1.77l-8.35.87Zm6.71 3.32c.58-.05 1.1.34 1.16.9l1.09 9.55c.06.55-.36 1.04-.93 1.1l-4.17.43c-.58.06-1.1-.33-1.16-.88l-1.09-9.56c-.06-.55.35-1.04.93-1.1l4.17-.44Zm4.45 29.72a1.04 1.04 0 0 0-1.16-.89l-4.17.44c-.58.06-1 .55-.93 1.1.06.55.58.95 1.16.89l4.17-.44c.57-.06.99-.55.93-1.1ZM3 6c0-1.1.94-2 2.1-2h8.39c1.16 0 2.1.9 2.1 2v36c0 1.1-.94 2-2.1 2h-8.4C3.95 44 3 43.1 3 42V6Zm9.15 3c0-.55-.47-1-1.05-1H7.48c-.58 0-1.05.45-1.05 1v19c0 .55.47 1 1.05 1h3.62c.58 0 1.05-.45 1.05-1V9Zm-.76 28c.58 0 1.05.45 1.05 1s-.47 1-1.05 1H7.2c-.57 0-1.04-.45-1.04-1s.47-1 1.05-1h4.2Zm5.25-31c0-1.1.93-2 2.1-2h8.38c1.16 0 2.1.9 2.1 2v36c0 1.1-.94 2-2.1 2h-8.39c-1.16 0-2.1-.9-2.1-2V6Zm9.15 21c0-.55-.47-1-1.05-1h-3.62c-.58 0-1.05.45-1.05 1v11c0 .55.47 1 1.05 1h3.62c.58 0 1.05-.45 1.05-1V27ZM24.74 8c.58 0 1.05.45 1.05 1v6c0 .55-.47 1-1.05 1h-3.62c-.58 0-1.05-.45-1.05-1V9c0-.55.47-1 1.05-1h3.62Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a54070915fef4afb12e24700e2bb701e.svg";
export { ForwardRef as ReactComponent };